import apiClient from '@/api/axios';
import { Badges } from '@/api/model';
import { ApiRouten } from '@/api/routen';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBadgeStore = defineStore('badgeStore', () => {
    // Initialzustand mit null. Effektiv aber nie null, da die Badges beim Laden der App initial geladen werden.
    const badges = ref<Badges>(null!);

    // Alle Badges initial laden
    const badgesLaden = async (kundennummer?: string | null) => {
        const route = ApiRouten.kundenbereichBadges(kundennummer);
        const response = await apiClient.get<Badges>(route);

        badges.value = response.data;
    };

    return {
        badges,
        badgesLaden
    };
});
